// What the scheduling panel calls things.
//
// The labels used to fall through to a single default, so a task where nobody
// had sent anything still read "Send More Options" and "You can still send
// additional options while this task remains active". Both promised a first
// send that had never happened, on the screen where a new front-desk hire is
// most likely to be guessing.
//
// The panel no longer has a Send button of its own. The two message boxes were
// merged: there is one reply box and one Send Response, and the panel writes
// into it. What used to be this file's sendButtonLabel / sendButtonHint is now
// a single hint on that one button, varying only by whether times are riding
// along with the text.
//
// Separated out so the wording can be tested without mounting the modal, the
// way nextBookableDate and suggestServiceMapping are.

export function sendResponseHint({ hasSlots }: { hasSlots: boolean }): string {
  const times = hasSlots ? ', and records the offered times against this task' : '';
  return `Sends the message to the patient as a text${times}. This one leaves the building — read the message first.`;
}

export function panelHelperText(status: string): string {
  switch (status) {
    case 'appointment_confirmed':
      // There is no longer a press that half-sends. Opening the picker is its
      // own button, and the single Send always sends.
      return 'This patient is booked. Offer different times opens the picker — nothing is sent until you press Send Response.';
    case 'appointment_cancelled':
      // Found in the acceptance pass: this read "This patient is booked" over
      // an appointment the office had just cancelled.
      return 'The booked time was cancelled. The patient has nothing on the calendar now — offer new times below if they want one.';
    case 'slots_sent':
    case 'no_slots_available':
      return 'Times have already gone to this patient. You can send more while the task is open.';
    case 'pending_approval':
      // The button no longer says "Approve", so the accountability lives here.
      return 'Written by AI and waiting in your reply box. Read it before sending — it goes to the patient as written.';
    default:
      return 'Pick times below and they go into your reply, or write your own message.';
  }
}
